import React from 'react';
import video1 from "../../images/service-icon-05.png";
import video2 from "../../images/services-image-05.png";

export const Content = () => {
    return (
        <div>
            <div id="services" class="services section">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="section-heading  wow fadeInDown" data-wow-duration="1s" data-wow-delay="0.5s">
                                <h6>Our Services</h6>
                                <h4>What Frishtey <em>Provides</em></h4>
                                <div class="line-dec"></div>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="naccs">
                                <div class="grid">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="menu">
                                                <div class="active">
                                                    <div class="thumb">
                                                        <span class="icon"><img src={video1} alt="" /></span>
                                                        Video Editing &amp; Animation
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-12">
                                            <ul class="nacc">
                                                <li class="active">
                                                    <div class="thumb">
                                                        <div class="row">
                                                            <div class="col-lg-6 align-self-center">
                                                                <div class="left-text">
                                                                    <h4>Video Editing &amp; Animation</h4>
                                                                    <p>We have been actively providing local & Globally search engine optimization services that help, businesses achieve the desired  search results. We develop local & Globally SEO strategies that are flexible for businesses and budgets of all sizes..</p>
                                                                    <div class="ticks-list"><span><i class="fa fa-check"></i> Local Optimization </span> <span><i class="fa fa-check"></i>Local Link Building</span> <span><i class="fa fa-check"></i> Local Citations </span>
                                                                        <span><i class="fa fa-check"></i> Become Global Brand</span> <span><i class="fa fa-check"></i> Targeted Geographic Campaignss</span> <span><i class="fa fa-check"></i>Increase Web Traffic, Leads, and Sale</span></div>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-6 align-self-center">
                                                                <div class="right-image">
                                                                    <img src={video2} alt="" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
